import { Separator } from '@ais-ui/ui-core';

import { useLocalization } from '@ais-ui/locale-management';
import { ChangePassword } from './ChangePassword';
import { MultiFactor } from './MultiFactor';

export function SettingsAuthenticationPage() {
  const { messages } = useLocalization();

  return (
    <div className="space-y-6 w-full">
      <div>
        <h3 className="text-2xl font-medium">
          {messages.settingsAuthenticationTitle}
        </h3>
        <p className="text-sm text-muted-foreground">
          {messages.settingsAuthenticationSubtitle}
        </p>
      </div>
      <Separator className="w-full" />
      <MultiFactor></MultiFactor>

      <Separator className="w-full" />
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-medium">
          {messages.settingsAuthenticationChangePasswordTitle}
        </h3>
      </div>
      <ChangePassword></ChangePassword>
    </div>
  );
}
